module.exports = __webpack_public_path__ + "assets/img/worldviewImg-4191f409.png";